import React, { memo } from 'react'
import { ILaneHistory } from 'types/carrier'
import { TableRow, TableCell } from 'transfix-ui'
import { columns } from './columns'

interface ILaneRowProps {
  lane: ILaneHistory
}

export const LaneRow = memo<ILaneRowProps>(({ lane }) => (
  <TableRow>
    {columns.map(({ cellType, formatter, label }) => (
      <TableCell key={label} type={cellType}>
        {formatter(lane)}
      </TableCell>
    ))}
  </TableRow>
))
